export const loginImage = require("../assets/images/login.jpg");
export default { loginImage };
